import React from 'react';
import Head from '../../layout/head.jsx'
import Content from '../../layout/content.jsx'
import Form from '../../layout/form.jsx'
import API from '../../../services/api.jsx'
import Loader from '../../layout/loader.jsx'
import { toast } from 'react-toastify'

class DeviceList extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			loading: false,
			breadcrumb: { title: 'Device list', path: '/clients/' + props.match.params.clientId + '/devices' },
			fields: {
				name: { label: 'Name', type: 'text', required: true },
				sku: { label: 'SKU', type: 'text', required: true },
				manualModeEnable: { label: 'Authorize manual mode', type: 'boolean', required: true }
			},
			device: {
				sku: null,
				type: null,
				client: this.props.match.params.clientId
			}
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	saveEntity(fields) {
		this.setState({ loading: true })
		API.create('devices', fields).then(() => {
			toast.success('Device has been created')
			this.props.history.push('/clients/' + this.props.match.params.clientId + '/devices')
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'New device'} breadcrumb={this.state.breadcrumb} tabs={this.state.tabs} />
				<Content>
					<Form fields={this.state.fields} entity={this.state.device} cancel={() => this.props.history.push('/clients/' + this.props.match.params.clientId + '/devices')} save={this.saveEntity} />
				</Content>
			</>
	}
}

export default DeviceList;

